export const backgroundDark = {
  paper: "#15222F",
  default: "#0D161F",
  container: "#152230",
  auth: "#16283A",
  authOuter: "#111C28",
  authCard: "#0D1C29",
  authBanner: "#0D1C29",
  authPrimary: "#5F5FFF",
  authProgressTrack: "#2C3E55",
  authProgressFill: "#5F5FFF",
};

export const backgroundLight = {
  paper: "#E2E2E2",
  default: "#F5F5F5",
  container: "#ffffff",
  auth: "#f5f5f5",
  authOuter: "#e8e8e8",
  authCard: "#ffffff",
  authBanner: "#2a2acc",
  authPrimary: "#3636F2",
  authProgressTrack: "#D0D4DD",
  authProgressFill: "#ffffff",
};
export const DarkSidebar = {
  sidebarBgColor: "#1F2A31",
  sidebarTextColor: "#FFF",
  sidebarMenuSelectedBgColor: "#0D161F",
  sidebarMenuSelectedTextColor: "#FFF",
};
export const LightSidebar = {
  sidebarBgColor: "#EBEBEB",
  sidebarTextColor: "#0D161F",
  sidebarMenuSelectedBgColor: "#F4F7FE",
  sidebarMenuSelectedTextColor: "rgba(0, 0, 0, 0.87)",
};

export const textLight = {
  primary: "#0D161F",
  secondary: "#7C858E",
  disabled: "#999CA0",
  authLabel: "#1a1a1a",
  authBannerTitle: "#ffffff",
  authBannerLabel: "#ffffff",
};

export const textDark = {
  primary: "#FFF",
  secondary: "#999CA0",
  disabled: "rgb(156, 163, 175)",
  authLabel: "#AAB0BD",
  authBannerTitle: "#ffffff",
  authBannerLabel: "#AAB0BD",
};

export const borderColorDark = {
  default: "#1D3144",
  authInput: "#2C3E55",
};

export const borderColorLight = {
  default: "#E2E2E2",
  authInput: "#e2e5ed",
};

export const statusLight = {
  error: {
    main: "#F97970",
    50: "#FEF3F2",
  },
  success: {
    main: "#6FE6A7",
    50: "#ECFDF3",
    100: "#D1FADF",
  },
  warning: {
    100: "#FFF7D4",
    500: "#FDA712",
    600: "#F79009",
    900: "#7E4510",
  },
};
export const statusDark = {
  error: {
    main: "#F04438",
    50: "#FEF3F2",
    500: "#F04438",
  },
  success: {
    main: "#22C55E1F",
    50: "#ECFDF3",
    100: "#D1FADF",
  },
  warning: {
    100: "#FFF7D4",
    500: "#FDA712",
    600: "#F79009",
    900: "#7E4510",
  },
};

export const defaultTheme = {
  theme: {
    palette: {
      primary: { main: "#3636F2", accentColor: "#1C2243" },
      secondary: { main: "#F0FDF4" },
      borderColor: borderColorDark,
      // cardBackgroundColor: "rgba(255, 255, 255, 0.08)",
      white: "#FFFFFF",
      black: "#000",
      gray: {
        25: "#FCFCFD",
        50: "#F9FAFB",
        100: "#F2F4F7",
        200: "#EAECF0",
        300: "#D0D5DD",
        400: "#98A2B3",
        500: "#667085",
        600: "#475467",
        900: "#111827",
      },
      grey: {
        "Cool Grey": {
          100: "#F3F4F6",
          200: "#E5E7EB", // border color
        },
      },
      error: {
        600: "#D92D20",
      },
      background: backgroundDark,
      boxShadowColor: "rgba(0, 0, 0, 0.07)",
      text: textDark,
      status: statusDark,
    },
    sideBar: {
      light: LightSidebar,
      dark: DarkSidebar,
    },
    font: {
      family: "Montserrat",
      size: {
        small: "12px",
        medium: "14px",
        large: "16px",
      },
    },
    headerMenu: {
      headerMenuSelectedBgColor: "#F3F4F6",
    },
    breadcrumbs: {
      height: 38,
    },
    tabs: {
      height: 56,
    },
    icons: {
      fill: "#98A2B3",
    },
    breakpoints: {
      xxs: 360,
      xs: 480,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1600,
      xxxl: 2560,
    },
    header: {
      height: 60,
      heightWithMargin: 68,
    },
    mobileMenu: {
      height: 60,
    },
  },
};
